/******************
 缓存相关操作
******************/
export default {
  saveUserType(type) {
    window.localStorage.setItem('userType', type)
  },

  getUserType(type) {
    return window.localStorage.getItem('userType')
  },

  saveData(key,val) {
    window.localStorage.setItem(key, val)
  },

  getData(key) {
    window.localStorage.getItem(key)
  },

  delData(key){
    window.localStorage.removeItem(key)
  },

  savePhone(phone) {
    window.localStorage.setItem('phone', phone)
  },

  getPhone() {
    return window.localStorage.getItem('phone')
  }
}



// WEBPACK FOOTER //
// ./src/common/cache.js